// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-select-focused .ant-select-selector,
.ant-select-selector:focus,
.ant-select-selector:hover {
  box-shadow: none !important;
  border-color: #d9d9d9 !important; /* Default border color */
  outline: none !important;
}

.ant-select-item-option {
  color: #182230 !important; /* Change text color */
  font-weight: 500;
}

/* Change placeholder text color */
.ant-select-selection-placeholder {
  color: #182230 !important; /* Change to desired color */
  font-weight: 500;
}

/* Increase Select height */
.ant-select-selector {
  height: 42px !important; /* Adjust height as needed */
  display: flex !important;
  align-items: center !important;
}

/* Increase Select height */
.custom-select-small .ant-select-selector {
  height: 32px !important; /* Adjust height as needed */
}

/* Increase height of dropdown items */
.ant-select-item {
  padding: 10px !important; /* Adjust padding for better spacing */
  font-size: 16px; /* Adjust font size if needed */
}

.ant-select-selection-placeholder {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

.ant-select-arrow {
  padding-top: 1rem;
  color: #182230 !important;
}

.ant-select-in-form-item {
  padding-top: 10px;
  display: flex !important;
  align-items: center !important;
}

.custom-select-selected .ant-select-selector {
  background-color: #eff6ff !important; /* bg-blue-50 */
  border: 1px solid #3b82f6 !important; /* border-blue-500 */
  color: #1d4ed8 !important; /* text-blue-700 */
  font-weight: bold !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomSelect/CustomSelect.module.scss"],"names":[],"mappings":"AAAA;;;EAGE,2BAAA;EACA,gCAAA,EAAA,yBAAA;EACA,wBAAA;AACF;;AAEA;EACE,yBAAA,EAAA,sBAAA;EACA,gBAAA;AACF;;AAEA,kCAAA;AACA;EACE,yBAAA,EAAA,4BAAA;EACA,gBAAA;AACF;;AAEA,2BAAA;AACA;EACE,uBAAA,EAAA,4BAAA;EACA,wBAAA;EACA,8BAAA;AACF;;AAEA,2BAAA;AACA;EACE,uBAAA,EAAA,4BAAA;AACF;;AAEA,sCAAA;AACA;EACE,wBAAA,EAAA,sCAAA;EACA,eAAA,EAAA,+BAAA;AACF;;AAGA;EACE,wBAAA;EACA,8BAAA;EACA,uBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,yBAAA;AAAF;;AAIA;EACE,iBAAA;EACA,wBAAA;EACA,8BAAA;AADF;;AAMA;EACE,oCAAA,EAAA,eAAA;EACA,oCAAA,EAAA,oBAAA;EACA,yBAAA,EAAA,kBAAA;EACA,4BAAA;AAHF","sourcesContent":[":global(.ant-select-focused .ant-select-selector),\n:global(.ant-select-selector:focus),\n:global(.ant-select-selector:hover) {\n  box-shadow: none !important;\n  border-color: #d9d9d9 !important; /* Default border color */\n  outline: none !important;\n}\n\n:global(.ant-select-item-option) {\n  color: #182230 !important; /* Change text color */\n  font-weight: 500;\n}\n\n/* Change placeholder text color */\n:global(.ant-select-selection-placeholder) {\n  color: #182230 !important; /* Change to desired color */\n  font-weight: 500;\n}\n\n/* Increase Select height */\n:global(.ant-select-selector) {\n  height: 42px !important; /* Adjust height as needed */\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* Increase Select height */\n:global(.custom-select-small .ant-select-selector) {\n  height: 32px !important; /* Adjust height as needed */\n}\n\n/* Increase height of dropdown items */\n:global(.ant-select-item) {\n  padding: 10px !important; /* Adjust padding for better spacing */\n  font-size: 16px; /* Adjust font size if needed */\n\n}\n\n:global(.ant-select-selection-placeholder) {\n  display: flex !important;\n  align-items: center !important;\n  height: 100% !important;\n}\n\n:global(.ant-select-arrow){\n  padding-top: 1rem;\n  color:#182230 !important;\n\n}\n\n:global(.ant-select-in-form-item){\n  padding-top: 10px;\n  display: flex !important;\n  align-items: center !important;\n}\n\n\n\n:global(.custom-select-selected .ant-select-selector) {\n  background-color: #eff6ff !important;   /* bg-blue-50 */\n  border: 1px solid #3b82f6 !important;   /* border-blue-500 */\n  color: #1d4ed8 !important;              /* text-blue-700 */\n  font-weight: bold !important; \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
